<script lang="ts">
  import * as facts from "./facts.json";
  import Quill from "quill";
  import { afterUpdate, onMount } from "svelte";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function updateBody(newBody) {
    dispatch("updateBody", {
      newBody,
    });
  }

  export let body;
  export let collapsed;

  let quillInstance;
  let editorData = { html: "" };
  let editorContainer;

  function setEditorContents(newBody) {
    if (newBody.length) {
      const delta = quillInstance.clipboard.convert(newBody);
      quillInstance.setContents(delta, "silent");
    }
  }

  onMount(() => {
    const randomFact =
      facts.default[Math.floor(Math.random() * facts.default.length)];

    quillInstance = new Quill(editorContainer, {
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] },
          "bold", "italic", "underline", "strike",
          "link", "code-block",
          { list: "ordered" }, { list: "bullet" },
          { align: [] }],
        ],
      },
      placeholder: randomFact,
      theme: "snow", // or 'bubble'
    });
    const container = editorContainer.getElementsByClassName("ql-editor")[0];

    quillInstance.on("text-change", function (delta, oldDelta, source) {
      editorContainer.dispatchEvent(
        new CustomEvent("text-change", {
          detail: {
            html: container.innerHTML,
            text: quillInstance.getText(),
          },
        })
      );
    });

    setEditorContents(body);
  });
</script>

<div
  class="editor"
  class:collapsed
  bind:this={editorContainer}
  on:text-change={(e) => updateBody(e.detail.html)}
/>

<style>
  .editor {
    border: none;
    min-height: 100px;
  }

  .editor.collapsed {
    min-height: 0;
    max-height: 50px;
    overflow: hidden;
    position: relative;
  }

  .editor.collapsed::after {
    content: "";
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 100%;
    background: linear-gradient(0deg, rgba(37,40,42,1) 0%, rgba(37,40,42,0.78) 48%, rgba(37,40,42,0) 100%); 
  }

  :global(.ql-editor.ql-blank::before) {
    color: #8f9099;
  }

  :global(.ql-toolbar.ql-snow) {
    border-color: #3f454a;
    padding: 0.25rem;
    border-radius: 4px;
  }

  :global(.ql-toolbar .ql-stroke) {
    stroke: #3f454a;
  }

  :global(.ql-toolbar .ql-picker) {
    color: #3f454a;
    /* #8c969f */
  }

  :global(.ql-toolbar .ql-picker-options) {
    background-color: #161616;
  }
</style>
